module.exports = __webpack_public_path__ + "static/media/des-3.59d30de8.png";